import React, { useCallback, useEffect, useRef, useState } from "react";
import { FormHandles } from "@unform/core";
import { Form } from "@unform/web";
import api from "../../services/api";
import { useProgress } from "../../hooks/progress";
import { writeStorage } from "../../utils/storage/storage";
import * as Yup from "yup";
import getValidationErrors from "../../utils/getValidationErrors";
import { useParams } from "react-router-dom";
import { Input } from "../../components/Inputs/InputRef";
import Button from "../Buttons";
import Checkbox from "@mui/material/Checkbox";
import { FormControlLabel } from "@material-ui/core";
import Toast from "../Toast/Toast";
import { useLocation } from "react-router-dom";
import errorIcon from "../Toast/Image/error.svg";

import {
  DivFlex,
  ChoiceText,
  DivImages,
  TitleText,
  DivInput,
  DivAutocomplete,
  DivMobile,
  InputLabelPF,
  InputLabelPJ,
  InputContainerNomes,
  TextPrivacidade,
  DivForm,
  InputContainer,
} from "./styles";
import { Autocomplete, TextField } from "@mui/material";
import ModalHistoricoConsumo from "../Modais/ModalHistoricoConsumo/ModalHistoricoConsumo";
import ModalOps from "../Modais/ModalOps";
import ModalTermos from "../Modais/ModalTermos/ModalTermos";

interface ICommercial {
  id: string | undefined;
  idCard: string | undefined;
  indicate: string | undefined;
}

interface IUtms {
  utmContent: string;
  utmTerm: string;
  utmCampaign: string;
  utmMedium: string;
  utmSource: string;
}

const HomeComponent: React.FC = () => {
  const { setLoad } = useProgress();
  const [estado, setEstado] = useState<any>([]);
  const [estadoFim, setEstadoFim] = useState("");
  const [concessionaria, setConcessionaria] = useState<any>([]);
  const [concessionariaFim, setConcessionariaFim] = useState<any>("");
  const useFormRef = useRef<FormHandles>(null);
  const [tipo, setTipo] = useState<string>("");
  const [modalIsOpenOps, setIsOpenOps] = useState<boolean>(false);
  const [tipoPessoa, setTipoPessoa] = useState<string>("");
  const [labelPessoa, setLabelPessoa] = useState("Nome completo");
  const [telefone, setTelefone] = useState<string>("");
  const [aceiteTermos, setTermoUso] = useState(1);
  const [, setCpfcnpj] = useState<string>("");
  const [, setValidateCpfCnpj] = useState<boolean>(true);
  const [modalIsOpen, setIsOpen] = useState<boolean>(false);
  const [isOpenHistoricoConsumo, setIsOpenHistoricoConsumo] =
    useState<boolean>(false);
  const [nomeRazao, setNomeRazao] = useState("");

  const [utms, setUtms] = useState<IUtms>();

  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

  const query = useQuery();

  const handleChangeCheckboxTermos = () => {
    setIsOpen(true);
  };

  const [list, setList] = useState<any>([]);

  const showToast = useCallback(
    (type: any) => {
      let toastProperties: {
        id: number;
        title: string;
        description: string;
        backgroundColor: string;
        icon: any;
      } | null = null;

      const id = Math.floor(Math.random() * 101 + 1);
      switch (type) {
        case "error":
          toastProperties = {
            id,
            title: "",
            description: "Erro ao enviar dados",
            backgroundColor: "#D72828",
            icon: errorIcon,
          };
          break;

        default:
          setList([]);
      }

      setList([...list, toastProperties]);
    },
    [list]
  );

  const handleChangeStep = useCallback((step: any) => {
    window.location.href = `/onboarding/step/${step}`;
  }, []);

  const { id: idRepresentative, idCard, indicate } = useParams<ICommercial>();
  writeStorage({
    key: "commercial",
    object: {
      id: idRepresentative,
      idCard: idCard,
      indicate: indicate,
    },
  });

  const checkLink = useCallback(async (id: any) => {
    try {
      const res = await api.get(`csp/usuario/validadorLink/${id}`);
      if (res.data.existe === 1) {
        return;
      } else if (res.data.existe === 0) {
        writeStorage({
          key: "repprovedlink",
          object: {
            situacao: res.data.existe,
          },
        });
        window.location.href = "/onboarding/repprovedlink";
      }
    } catch (error) {
      console.error("Erro ao chamar a API:", error);
    }
  }, []);

  useEffect(() => {
    if (indicate) {
      checkLink(indicate);
    }
  }, [indicate, checkLink]);

  const handleChange = useCallback(
    (e: any) => {
      const { value } = e.target;
      setTipo(value);
    },
    [setTipo]
  );

  const closeModal = () => {
    setIsOpenOps(false);
    setIsOpen(false);
  };

  const handleApiErrors = useCallback(
    (error: any, local: string) => {
      if (error.message === "Network Error") {
        if (!navigator.onLine) {
          showToast("error");
        }
      } else {
        showToast("error");
      }
    },
    [showToast]
  );

  const closeModalConsumo = () => {
    setIsOpenHistoricoConsumo(false);
    handleChangeStep(1);
  };

  const handleOpenModalHistorico = useCallback(() => {
    setIsOpenHistoricoConsumo(true);
  }, []);

  const handleSubmit = useCallback(
    async (data: any) => {
      setLoad(true);
      try {
        useFormRef.current?.setErrors({});
        let schema = Yup.object();

        if (tipoPessoa === "PF") {
          schema = schema.shape({
            isValid: Yup.boolean().default(true),
            nomeRazao: Yup.string().required("Nome é obrigatório"),
            telefone: Yup.string().required("Telefone é obrigatório"),
          });
        }

        if (tipoPessoa === "PJ") {
          schema = schema.shape({
            nomeRazao: Yup.string().required("Razão social é obrigatória"),
            telefone: Yup.string().required("Telefone é obrigatório"),
          });
        }

        await schema.validate(data, {
          abortEarly: false,
        });

        if (estadoFim === "Outros estados") {
          setIsOpenOps(true);
        } else {
          const params = {
            estado: estadoFim,
            concessionaria: concessionariaFim,
            tipoResi: tipo,
            aceiteMarketing: 0,
            termoCondicao: aceiteTermos,
            representante: idRepresentative,
            indicacao: indicate,
            nomeRazao: data.nomeRazao,
            telefone: data.telefone,
            tipoPessoa: tipoPessoa,
            utmContent: utms?.utmContent ||"",
            utmTerm: utms?.utmTerm ||"",
            utmCampaign: utms?.utmCampaign ||"",
            utmMedium: utms?.utmMedium ||"",
            utmSource: utms?.utmSource ||"",
          };

          await api
            .post(`csp/usuario/criar/`, params)
            .then(({ status, data }) => {
              if (status === 201) {
                writeStorage({
                  key: "home",
                  object: {
                    tipo: tipo,
                    estado: estadoFim,
                    idCard: data.idCard,
                    tipoResi: tipo,
                    aceiteMarketing: 0,
                    termoCondicao: aceiteTermos,
                    representante: idRepresentative,
                    indicacao: indicate,
                    nomeRazao: data.nomeRazao,
                    telefone: data.telefone,
                    pessoa: tipoPessoa,
                    Concessionaria: concessionariaFim,
                  },
                });
                handleOpenModalHistorico();
              }
            })
            .catch(() => {
              setLoad(false);
              showToast("error");
            });
        }
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);
          useFormRef.current?.setErrors(errors);
        } else {
          setLoad(false);
          handleApiErrors(error, "salvar registro");
        }
      }
      setLoad(false);
    },
    [
      indicate,
      setLoad,
      tipoPessoa,
      concessionariaFim,
      estadoFim,
      tipo,
      aceiteTermos,
      idRepresentative,
      handleOpenModalHistorico,
      showToast,
      handleApiErrors,
    ]
  );

  const handleChangeCheck = (e: any) => {
    const { value } = e.target;
    setTipoPessoa(value);
    setCpfcnpj("");
    setValidateCpfCnpj(false);
  };

  useEffect(() => {
    if (tipoPessoa === "PJ") {
      setLabelPessoa("Razão social");
      setTipoPessoa("PJ");
    } else {
      setLabelPessoa("Nome completo");
      setTipoPessoa("PF");
    }
  }, [tipoPessoa, setTipoPessoa]);

  const handleChangeTermoUso = () => {
    setTermoUso(Number(!aceiteTermos));
  };

  const listaEstados = useCallback(async () => {
    setLoad(true);
    await api
      .get("/csp/estadoconce/consultar")
      .then((res) => {
        let states = [];
        const {
          data: { estados },
        } = res;
        for (const k in estados) {
          const { nome, UF } = estados[k];
          states.push({ value: UF, label: nome });
        }
        setEstado(states);
      })
      .catch((err) => {
        setLoad(false);
        console.error(err);
      });
    setLoad(false);
  }, [setEstado, setLoad]);

  const listaConcessionaria = useCallback(
    async (value: any) => {
      setLoad(true);
      await api
        .get("/csp/estadoconce/consultar/" + value)
        .then((res) => {
          let arrayConcessionarias = [];
          const {
            data: { concessionarias },
          } = res;
          for (const k in concessionarias) {
            const { nome, id } = concessionarias[k];
            arrayConcessionarias.push({ value: id, label: nome });
          }
          setConcessionaria(arrayConcessionarias);
        })
        .catch((err) => {
          setLoad(false);
          console.error(err);
        });
      setLoad(false);
    },
    [setLoad]
  );

  const handleChangeEstado = useCallback(
    (e: any) => {
      setEstadoFim(e.label);
      listaConcessionaria(e.value);
      setConcessionariaFim("");
    },
    [listaConcessionaria]
  );

  const handleChangeConcessionaria = useCallback((e: any) => {
    setConcessionariaFim(e.label);
  }, []);

  useEffect(() => {
    if (Object.keys(estado).length === 0) {
      listaEstados();
    }
  }, [estado, listaEstados]);

  const handleChangeTelefone = (e: any) => {
    const { value } = e.target;
    if (value.length <= 14) {
      setTelefone(
        (e.target.value = value
          .replace(/\D/g, "")
          .replace(/(\d{2})(\d)/, "($1) $2")
          .replace(/(\d{4})(\d)/, "$1-$2")
          .replace(/(-\d{4})(\d+?)$/, "$1"))
      );
    } else {
      setTelefone(
        (e.target.value = value
          .replace(/\D/g, "")
          .replace(/(\d{2})(\d)/, "($1) $2")
          .replace(/(\d{5})(\d)/, "$1-$2")
          .replace(/(-\d{4})(\d+?)$/, "$1"))
      );
    }
  };

  const excludeStorage = useCallback(async () => {
    //LocalStorage
    localStorage.removeItem("@AXS-adesao");
    localStorage.removeItem("@AXS-economia");
    localStorage.removeItem("@AXS-home");
    localStorage.removeItem("@AXS-beneficios");
    localStorage.removeItem("@AXS-card");
    localStorage.removeItem("@AXS-holderdata");
    localStorage.removeItem("@AXS-filldata");
    localStorage.removeItem("@AXS-consumo");
    localStorage.removeItem("@AXS-commercial");
    localStorage.removeItem("@AXS-modalCheck");
    localStorage.removeItem("@AXS-bancos");
    localStorage.removeItem("@AXS-success");
    localStorage.removeItem("@AXS-confirmationFatura");
    localStorage.removeItem("@AXS-confirmationData");
    localStorage.removeItem("@AXS-repprovedlink");
    //SessionStorage
    sessionStorage.removeItem("@AXS-adesao");
    sessionStorage.removeItem("@AXS-economia");
    sessionStorage.removeItem("@AXS-home");
    sessionStorage.removeItem("@AXS-beneficios");
    sessionStorage.removeItem("@AXS-card");
    sessionStorage.removeItem("@AXS-holderdata");
    sessionStorage.removeItem("@AXS-filldata");
    sessionStorage.removeItem("@AXS-consumo");
    sessionStorage.removeItem("@AXS-commercial");
    sessionStorage.removeItem("@AXS-modalCheck");
    sessionStorage.removeItem("@AXS-bancos");
    sessionStorage.removeItem("@AXS-success");
    sessionStorage.removeItem("@AXS-confirmationFatura");
    sessionStorage.removeItem("@AXS-confirmationData");
    sessionStorage.removeItem("@AXS-repprovedlink");
  }, []);

  const [hasCheckedVersion, setHasCheckedVersion] = useState(false);

  useEffect(() => {
    if (!hasCheckedVersion) {
      excludeStorage();
      setHasCheckedVersion(true);
    }
  }, [excludeStorage, hasCheckedVersion]);

  useEffect(() => {
    setUtms({
      utmContent: query.get("utm_content") || "",
      utmSource: query.get("utm_source") || "",
      utmCampaign: query.get("utm_campaign") || "",
      utmMedium: query.get("utm_medium") || "",
      utmTerm: query.get("utm_term") || "",
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Toast toastList={list} autoDelete={true} />
      <DivForm>
        <ModalOps
          isOpen={modalIsOpenOps}
          onRequestClose={closeModal}
          recipient={useFormRef.current?.getFieldValue("nomeRazao")}
          estado={estado}
          tipo={tipo}
        />
        <ModalHistoricoConsumo
          isOpenHistoricoConsumo={isOpenHistoricoConsumo}
          onRequestCloseModal={closeModalConsumo}
        />
        <ModalTermos isOpen={modalIsOpen} onRequestClose={closeModal} />

        <TitleText>Descubra o quanto você pode economizar</TitleText>
        <ChoiceText>Selecione onde deseja economizar:</ChoiceText>
        <Form
          ref={useFormRef}
          onSubmit={handleSubmit}
          placeholder={undefined}
          initialData={{
            tipo: "Apartamento",
            estado: 1,
          }}
          onPointerEnterCapture={undefined}
          onPointerLeaveCapture={undefined}
        >
          <DivMobile>
            <DivFlex>
              <DivImages>
                <input
                  type="radio"
                  id="idCasaMobile"
                  name="grupoTarifario"
                  /*  value="Casa" */
                  defaultValue="Casa/apto"
                  checked={tipo === "Casa/apto"}
                  onChange={handleChange}
                />
                <label htmlFor="idCasaMobile" className="casa">
                  <div>Casa ou apartamento</div>
                </label>

                <input
                  type="radio"
                  id="idComercioMobile"
                  name="grupoTarifario"
                  /*  value="Comércio" */
                  defaultValue="Comércio"
                  checked={tipo === "Comércio"}
                  onChange={handleChange}
                />
                <label htmlFor="idComercioMobile" className="comercio">
                  <div>Comércio</div>
                </label>

                <input
                  type="radio"
                  id="idApartamentoMobile"
                  name="grupoTarifario"
                  /*  value="Apartamento" */
                  defaultValue="Rural"
                  checked={tipo === "Rural"}
                  onChange={handleChange}
                />
                <label htmlFor="idApartamentoMobile" className="apartamento">
                  <div>Rural</div>
                </label>
              </DivImages>
            </DivFlex>
          </DivMobile>

          <ChoiceText>
            Selecione o estado em que o imóvel está localizado:
          </ChoiceText>
          <DivInput>
            <DivAutocomplete>
              <Autocomplete
                disablePortal
                options={estado}
                id="isNotState"
                size="small"
                getOptionLabel={(option: any) => option.label}
                onChange={(event, label: any) => handleChangeEstado(label)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Selecione um estado"
                    name="estado"
                    inputRef={useFormRef}
                    variant="outlined"
                  />
                )}
              />
            </DivAutocomplete>
          </DivInput>

          <ChoiceText>Selecione a sua concessionária:</ChoiceText>
          <DivInput>
            <DivAutocomplete>
              <Autocomplete
                disablePortal
                options={concessionaria}
                id="isNotState"
                size="small"
                noOptionsText={"Selecione seu estado"}
                //getOptionLabel={(option: any) => option.label}
                onChange={(event, label) => handleChangeConcessionaria(label)}
                value={concessionariaFim}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Selecione uma concessionária"
                    name="concessionária"
                    inputRef={useFormRef}
                    value={concessionariaFim}
                    variant="outlined"
                  />
                )}
              />
            </DivAutocomplete>
          </DivInput>
          <DivInput>
            <ChoiceText>Informe seus dados pessoais:</ChoiceText>
            <InputContainer>
              <InputLabelPF>
                <input
                  type={"radio"}
                  name="radio"
                  onChange={handleChangeCheck}
                  placeholder={labelPessoa}
                  value="PF"
                  checked={
                    tipoPessoa === "PF" ||
                    tipoPessoa === undefined ||
                    tipoPessoa === ""
                  }
                />
                Pessoa física
              </InputLabelPF>
              <InputLabelPJ>
                <input
                  type={"radio"}
                  name="radio"
                  onChange={handleChangeCheck}
                  value="PJ"
                  checked={tipoPessoa === "PJ"}
                  placeholder={labelPessoa}
                />
                Pessoa jurídica
              </InputLabelPJ>
            </InputContainer>

            <InputContainerNomes>
              <Input
                label={labelPessoa}
                placeholder={labelPessoa}
                type="text"
                name="nomeRazao"
                onChange={(e) => setNomeRazao(e.target.value)}
              />
              <Input
                onChange={handleChangeTelefone}
                label="Telefone ou celular"
                placeholder="Telefone ou celular"
                type="text"
                name="telefone"
              />
            </InputContainerNomes>
            <div>
              <FormControlLabel
                control={
                  <Checkbox
                    name="registerterms"
                    onChange={handleChangeTermoUso}
                    checked={Boolean(aceiteTermos)}
                    sx={{
                      color: "#6C5AF4",
                      "&.Mui-checked": {
                        color: "#6C5AF4",
                      },
                    }}
                  />
                }
                label="Eu concordo com os termos e condições de uso da AXS Energia e autorizo a utilização dos meus dados cadastrais para fins comerciais e de marketing"
              />
              <span className={aceiteTermos ? "InvalidoDisabled" : "Invalido"}>
                Obrigatório aceitar os termos e condições da AXS
              </span>
              <br />

              <TextPrivacidade
                className="TermosPrivacidade"
                onClick={handleChangeCheckboxTermos} //Versão hyperlink //Acesse a politica de privacidade
              >
                {" "}
                Acesse a politica de privacidade
              </TextPrivacidade>
              <br />
            </div>

            <Button
              type="submit"
              id="btnHomeNext"
              textButton="Continuar"
              onClick={() => ""}
              disabled={
                !Boolean(aceiteTermos) ||
                !Boolean(estado) ||
                !Boolean(tipo) ||
                !Boolean(nomeRazao) ||
                !Boolean(telefone.length >= 12) ||
                !Boolean(concessionariaFim)
              }
            ></Button>
            <div style={{ paddingBottom: "100px" }}></div>
          </DivInput>
        </Form>
      </DivForm>
    </>
  );
};

export default HomeComponent;
